import { render, staticRenderFns } from "./FormProgramSpecialization.vue?vue&type=template&id=00ed490f&"
import script from "./FormProgramSpecialization.vue?vue&type=script&lang=js&"
export * from "./FormProgramSpecialization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports